import React, { useContext, useEffect } from 'react';

import { Typography, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { connectStateResults } from 'react-instantsearch-dom';

import FilterIcon from '../../../../assets/icons/FilterIcon';
import { DiscoverContext } from '../../../../context/DiscoverContext';
import { colorsPalette } from '../../../../theme';
import ViewSwitcher from '../ViewSwitcher';
import useStyles from './styles';

export const SearchResults = ({
  searchResults,
  setItemsCount,
  setPage,
  resultsFunc,
  withToggle = false,
}) => {
  const { t } = useTranslation();
  const classes = useStyles(withToggle)();
  const page = searchResults?.page;
  const nbHits = searchResults?.nbHits;

  const { setOpenFiltersPanel, searchState, setTempSearchState } = useContext(DiscoverContext);

  useEffect(() => {
    setPage && setPage(page);
  }, [page, setPage]);

  useEffect(() => {
    setItemsCount && setItemsCount(nbHits);
  }, [nbHits, setItemsCount]);

  return (
    <div className={classes.searchResult}>
      <Typography data-testid="resultsAmount" className={classes.text}>
        {nbHits} {resultsFunc(nbHits)}
      </Typography>
      <div className={classes.buttonsWrapper}>
        <Button
          className={classes.filterBtn}
          onClick={() => {
            setTempSearchState(searchState);
            setOpenFiltersPanel(true);
          }}
        >
          <FilterIcon color={colorsPalette.gray} className={classes.icon} />
          {t('page.discover.filters')}
        </Button>
        {withToggle && <ViewSwitcher setPage={setPage} />}
      </div>
    </div>
  );
};

export default connectStateResults(SearchResults);
